(function () {
  var WAIT_MS = 10000;
  var productCache = {};

  function start() {
    document.querySelectorAll('[data-custom-bundle]').forEach(initCustomBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);

  function qs(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function asPercent(value) {
    var number = Number(value);
    if (!isFinite(number) || number <= 0) return 0;
    if (number <= 1) number = number * 100;
    if (number > 100) return 0;
    return Math.round(number);
  }

  function formatMoney(cents, moneyFormat) {
    cents = Math.max(0, Math.round(Number(cents) || 0));
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents, moneyFormat || window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function priceParts(cents, symbol) {
    cents = Math.max(0, Math.round(Number(cents) || 0));
    var frac = String(cents % 100);
    if (frac.length < 2) frac = '0' + frac;
    return {
      symbol: symbol || '$',
      dollars: String(Math.floor(cents / 100)),
      frac: frac
    };
  }

  function lineDiscountCents(cents, pct) {
    if (pct <= 0 || cents <= 0) return 0;
    return Math.round(cents * pct / 100);
  }

  function discountedUnitCents(cents, pct) {
    return Math.max(0, cents - lineDiscountCents(cents, pct));
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function createEl(html) {
    var wrap = document.createElement('div');
    wrap.innerHTML = html.trim();
    return wrap.firstElementChild;
  }

  function rootUrl(root) {
    var base = root || '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return base;
  }

  function imageUrl(value) {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value.src || value.url || '';
  }

  function productImage(product, variant) {
    return imageUrl(variant && variant.featured_image) ||
      imageUrl(product && product.featured_image) ||
      imageUrl(product && product.images && product.images[0]) ||
      '';
  }

  function isDeleted(variant) {
    return !variant || String(variant.was_deleted) === '1';
  }

  function allowedVariantIds(bundleProduct) {
    var variants = bundleProduct && bundleProduct.variants;
    if (!variants) return [];
    return Object.keys(variants).filter(function (id) {
      return !isDeleted(variants[id]);
    });
  }

  function isActiveProduct(product) {
    if (!product || product.id == null || product.id === '') return false;
    if (product.status && String(product.status) !== 'active') return false;
    return true;
  }

  function hasOutOfStockTag(productJson) {
    var tags = productJson && productJson.tags;
    if (!tags) return false;
    var list = Array.isArray(tags) ? tags : String(tags).split(',');
    var i;
    for (i = 0; i < list.length; i++) {
      var value = String(list[i] || '').trim().toLowerCase();
      if (value === 'out of stock' || value === 'out-of-stock' || value === 'out_of_stock') return true;
    }
    return false;
  }

  function isPurchasable(productJson, variant, forcedSoldOut) {
    if (forcedSoldOut || hasOutOfStockTag(productJson)) return false;
    if (!variant || variant.available === false) return false;
    if (productJson && productJson.available === false) return false;
    return true;
  }

  function addProducts(map, products, required) {
    if (!products) return;
    Object.keys(products).forEach(function (key) {
      var product = products[key];
      if (!isActiveProduct(product)) return;
      var id = String(product.id);
      if (!map[id]) {
        map[id] = product;
        map[id]._required = !!required || String(product.required) === '1';
        return;
      }
      if (required || String(product.required) === '1') map[id]._required = true;
    });
  }

  function bundleProducts(bundle) {
    var map = {};
    addProducts(map, bundle.products, false);
    addProducts(map, bundle.required_products, true);
    if (bundle.sections && bundle.sections.length) {
      bundle.sections.forEach(function (section) {
        addProducts(map, section && section.products, false);
      });
    }
    return Object.keys(map).map(function (id) { return map[id]; });
  }

  function includesCurrent(products, productId, handle) {
    var i;
    for (i = 0; i < products.length; i++) {
      if (productId && String(products[i].id) === String(productId)) return true;
      if (handle && products[i].handle === handle) return true;
    }
    return false;
  }

  function bundleList(bundles) {
    if (!bundles) return [];
    if (Array.isArray(bundles)) return bundles.slice();
    if (typeof bundles === 'object') {
      return Object.keys(bundles).map(function (key) { return bundles[key]; }).filter(Boolean);
    }
    return [];
  }

  function pickBundle(bundles, productId, handle) {
    var list = bundleList(bundles).sort(function (a, b) {
      return (Number(a.priority) || 0) - (Number(b.priority) || 0);
    });
    var i;
    for (i = 0; i < list.length; i++) {
      if (String(list[i].status || 'enabled') !== 'enabled') continue;
      var products = bundleProducts(list[i]);
      if (products.length < 2) continue;
      if (includesCurrent(products, productId, handle)) return list[i];
    }
    return null;
  }

  function waitForBundler(timeout) {
    return new Promise(function (resolve) {
      var settled = false;
      var timer;
      var poll;

      function ready() {
        return window.bndlr && typeof window.bndlr.getBundles === 'function';
      }

      function readBundles() {
        try {
          return window.bndlr.getBundles();
        } catch (e) {
          return null;
        }
      }

      function finish(value) {
        if (settled) return;
        settled = true;
        document.removeEventListener('bundler:loaded', onLoaded);
        if (timer) clearTimeout(timer);
        if (poll) clearInterval(poll);
        resolve(value);
      }

      function onLoaded() {
        if (ready()) finish(readBundles());
      }

      if (ready()) {
        finish(readBundles());
        return;
      }

      document.addEventListener('bundler:loaded', onLoaded);
      poll = setInterval(function () {
        if (ready()) finish(readBundles());
      }, 200);
      timer = setTimeout(function () {
        finish(ready() ? readBundles() : null);
      }, timeout);
    });
  }

  function fetchProduct(root, handle) {
    if (!handle) return Promise.reject(new Error('missing handle'));
    if (productCache[handle]) return productCache[handle];
    var request = fetch(rootUrl(root) + 'products/' + handle + '.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('product');
      return response.json();
    }).catch(function (error) {
      delete productCache[handle];
      throw error;
    });
    productCache[handle] = request;
    return request;
  }

  function pickVariant(productJson, bundleProduct, preferredId) {
    var allowed = allowedVariantIds(bundleProduct);
    var variants = (productJson && productJson.variants) || [];

    function find(id) {
      var i;
      for (i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function allowedVariant(variant) {
      if (!variant) return false;
      if (!allowed.length) return true;
      return allowed.indexOf(String(variant.id)) !== -1;
    }

    var preferred = preferredId ? find(preferredId) : null;
    if (allowedVariant(preferred)) return preferred;

    var i;
    for (i = 0; i < allowed.length; i++) {
      var match = find(allowed[i]);
      if (match && match.available) return match;
    }
    for (i = 0; i < allowed.length; i++) {
      var any = find(allowed[i]);
      if (any) return any;
    }
    for (i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0] || null;
  }

  function initCustomBundle(root) {
    if (!root || root.dataset.bundleReady === 'true') return;
    root.dataset.bundleReady = 'true';

    var section = root.closest('.custom-bundle');
    var thumbs = qs(root, '[data-bundle-thumbs]');
    var list = qs(root, '[data-bundle-list]');
    var badge = qs(root, '[data-bundle-badge]');
    var badgeText = qs(root, '[data-bundle-badge-text]');
    var countLabel = qs(root, '[data-bundle-count-label]');
    var totalEl = qs(root, '[data-bundle-total]');
    var saveEl = qs(root, '[data-bundle-save]');
    var atc = qs(root, '[data-bundle-atc]');
    var errorEl = qs(root, '[data-bundle-error]');
    var deco = qs(root, '[data-bundle-deco]');
    var emptyEl = qs(root, '[data-bundle-empty]');
    var boundsEl = root.closest('.wrapper') || section || root;
    var moneyFormat = root.getAttribute('data-money-format');
    var moneySymbol = root.getAttribute('data-money-symbol') || '$';
    var assets = {
      plus: root.getAttribute('data-icon-plus') || '',
      checkOff: root.getAttribute('data-icon-check-off') || '',
      checkOn: root.getAttribute('data-icon-check-on') || '',
      star: root.getAttribute('data-icon-star') || '',
      size: root.getAttribute('data-icon-size') || ''
    };
    var currentSheet = root.getAttribute('data-current-sheet') || '';
    var discountTwo = asPercent(root.getAttribute('data-discount-two')) || 5;
    var discountThree = asPercent(root.getAttribute('data-discount-three')) || 10;
    var productId = root.getAttribute('data-product-id') || '';
    var productHandle = root.getAttribute('data-product-handle') || '';
    var preferredVariantId = root.getAttribute('data-variant-id') || '';
    var catalogRoot = root.getAttribute('data-root') || '/';
    var addUrl = root.getAttribute('data-add-url') || '/cart/add.js';
    var items = [];
    var bundle = null;
    var rendered = false;

    function syncDecoVisibility() {
      if (!deco) return;
      var measureEl = qs(deco, 'img') || deco;
      var decoBox = measureEl.getBoundingClientRect();
      var boundsBox = boundsEl.getBoundingClientRect();
      if (decoBox.width === 0 || decoBox.height === 0) return;
      var fits = decoBox.right <= boundsBox.right + 0.5 && decoBox.left >= boundsBox.left - 0.5;
      deco.classList.toggle('is-hidden', !fits);
    }

    function selectedItems() {
      return items.filter(function (item) { return item.checked && item.available && item.variantId; });
    }

    function discountPercent(count) {
      if (count >= 3) return discountThree || 10;
      if (count === 2) return discountTwo || 5;
      return 0;
    }

    function lineCents(item, pct) {
      var unit = discountedUnitCents(item.price, pct);
      return {
        unit: unit,
        line: unit * item.quantity,
        full: item.price * item.quantity
      };
    }

    function selectedTotals() {
      var selected = selectedItems();
      var pct = discountPercent(selected.length);
      var subtotal = 0;
      var total = 0;

      selected.forEach(function (item) {
        var line = lineCents(item, pct);
        subtotal += line.full;
        total += line.line;
      });

      return {
        count: selected.length,
        pct: pct,
        total: total,
        save: Math.max(0, subtotal - total)
      };
    }

    function updateUI() {
      var totals = selectedTotals();
      items.forEach(function (item) {
        var on = item.checked && item.available && totals.pct > 0;
        setRowPrice(item, on ? discountedUnitCents(item.price, totals.pct) : item.price);
        if (item.card) item.card.classList.toggle('is-unchecked', !item.checked);
        if (item.row) item.row.classList.toggle('is-unchecked', !item.checked);
      });
      if (countLabel) {
        countLabel.textContent = 'Total for ' + totals.count + (totals.count === 1 ? ' item' : ' items');
      }
      if (totalEl) totalEl.textContent = formatMoney(totals.total, moneyFormat);
      if (saveEl) {
        saveEl.textContent = 'You save ' + formatMoney(totals.save, moneyFormat);
        saveEl.hidden = totals.save <= 0;
      }
      if (badge) badge.hidden = totals.pct <= 0;
      if (badgeText) {
        badgeText.textContent = totals.pct > 0
          ? 'Bundle discount — ' + totals.pct + '% off'
          : 'Bundle discount';
      }
      if (atc) atc.disabled = totals.count === 0 || atc.classList.contains('is-loading');
    }

    function setRowPrice(item, cents) {
      if (!item.priceEl) return;
      var amount = cents == null ? item.price : cents;
      var parts = priceParts(amount, moneySymbol);
      if (item.compareEl) {
        var discounted = amount < item.price;
        item.compareEl.hidden = !discounted;
        if (discounted) item.compareEl.textContent = formatMoney(item.price, moneyFormat);
      }
      var symbolEl = qs(item.priceEl, '.custom-bundle__price-symbol');
      var intEl = qs(item.priceEl, '.custom-bundle__price-int');
      var fracEl = qs(item.priceEl, '.custom-bundle__price-frac');
      if (symbolEl) symbolEl.textContent = parts.symbol;
      if (intEl) intEl.textContent = parts.dollars;
      if (fracEl) fracEl.textContent = parts.frac;
    }

    function showEmpty() {
      if (emptyEl) emptyEl.hidden = false;
      if (section) {
        section.classList.remove('is-waiting');
        if (!section.classList.contains('is-design')) section.classList.add('is-empty');
      }
    }

    function bundleHasUnavailable() {
      var i;
      for (i = 0; i < items.length; i++) {
        if (!items[i].available) return true;
      }
      return false;
    }

    function syncBundleVisibility() {
      if (items.length < 2 || bundleHasUnavailable()) {
        showEmpty();
        return;
      }
      if (!rendered) {
        mount(items);
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      if (section) section.classList.remove('is-waiting', 'is-empty');
      updateUI();
    }

    function buildRow(item) {
      var parts = priceParts(item.price, moneySymbol);
      var stars = '';
      var i;
      for (i = 0; i < 5; i++) {
        stars += '<span class="custom-bundle__star"><img src="' + assets.star + '" width="18" height="18" alt="" loading="lazy"></span>';
      }
      var locked = !!item.isCurrent;
      return createEl(
        '<label class="custom-bundle__row' + (item.available ? '' : ' is-disabled') + (locked ? ' is-locked' : '') + '" data-bundle-row>' +
          '<span class="custom-bundle__row-main">' +
            '<span class="custom-bundle__check">' +
              '<input class="custom-bundle__checkbox" type="checkbox" data-bundle-checkbox' +
                (item.checked ? ' checked' : '') +
                (item.available && !locked ? '' : ' disabled') +
                ' aria-label="' + escapeHtml(item.title) + '">' +
              '<img class="custom-bundle__check-icon custom-bundle__check-off" src="' + assets.checkOff + '" width="24" height="24" alt="" loading="lazy">' +
              '<img class="custom-bundle__check-icon custom-bundle__check-on" src="' + assets.checkOn + '" width="24" height="24" alt="" loading="lazy">' +
            '</span>' +
            '<span class="custom-bundle__row-title" title="' + escapeHtml(item.title) + '"><span class="custom-bundle__row-title-text">' + escapeHtml(item.title) + '</span></span>' +
          '</span>' +
          '<span class="custom-bundle__row-meta">' +
            '<span class="custom-bundle__prices">' +
              '<span class="custom-bundle__price-compare" hidden></span>' +
              '<span class="custom-bundle__item-price">' +
              '<span class="custom-bundle__price-symbol">' + escapeHtml(parts.symbol) + '</span>' +
              '<span class="custom-bundle__price-int">' + parts.dollars + '</span>' +
              '<span class="custom-bundle__price-dot">.</span>' +
              '<span class="custom-bundle__price-frac">' + parts.frac + '</span>' +
            '</span>' +
            '</span>' +
            '<span class="custom-bundle__stars" aria-hidden="true">' + stars + '</span>' +
          '</span>' +
        '</label>'
      );
    }

    function mount(nextItems) {
      if (!nextItems.length || !thumbs || !list) {
        showEmpty();
        return;
      }

      thumbs.innerHTML = '';
      list.innerHTML = '';
      items = nextItems;

      items.forEach(function (item, index) {
        if (index > 0) {
          thumbs.appendChild(createEl(
            '<span class="custom-bundle__plus" aria-hidden="true">' +
              '<img src="' + assets.plus + '" width="42" height="42" alt="" loading="lazy">' +
            '</span>'
          ));
        }

        var imageHtml = item.image
          ? '<div class="custom-bundle__card-image"><img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" width="140" height="122" loading="lazy"></div>'
          : '';
        var sizeHtml = currentSheet
          ? '<div class="custom-bundle__card-size">' +
              '<span class="custom-bundle__card-size-icon"><img src="' + assets.size + '" width="13" height="12" alt="" loading="lazy"></span>' +
              '<p class="custom-bundle__card-size-text">' + escapeHtml(currentSheet) + '</p>' +
            '</div>'
          : '';
        var cardWrap = document.createElement('div');
        cardWrap.innerHTML =
          '<article class="custom-bundle__card' + (item.checked ? '' : ' is-unchecked') + '" data-bundle-card="' + escapeHtml(item.productId) + '">' +
            sizeHtml +
            '<div class="custom-bundle__card-body">' +
              imageHtml +
              '<p class="custom-bundle__card-title" title="' + escapeHtml(item.title) + '">' + escapeHtml(item.title) + '</p>' +
            '</div>' +
          '</article>';
        item.card = cardWrap.firstElementChild;
        thumbs.appendChild(item.card);

        item.row = buildRow(item);
        item.checkbox = qs(item.row, '[data-bundle-checkbox]');
        item.priceEl = qs(item.row, '.custom-bundle__item-price');
        item.compareEl = qs(item.row, '.custom-bundle__price-compare');
        list.appendChild(item.row);

        if (item.checkbox) {
          item.checkbox.addEventListener('change', function () {
            if (item.isCurrent) {
              item.checked = item.available;
              item.checkbox.checked = item.checked;
              item.checkbox.disabled = true;
              updateUI();
              return;
            }
            item.checked = item.checkbox.checked;
            updateUI();
          });
        }
      });

      rendered = true;
      if (emptyEl) emptyEl.hidden = true;
      if (section) section.classList.remove('is-waiting', 'is-empty');
      updateUI();
      syncDecoVisibility();
      window.addEventListener('resize', syncDecoVisibility);
      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(syncDecoVisibility).observe(boundsEl);
      }
    }

    function applyVariant(item, variant) {
      if (!variant) return;
      var allowed = !item.allowedIds.length || item.allowedIds.indexOf(String(variant.id)) !== -1;
      if (!allowed) return;
      item.variantId = Number(variant.id) || item.variantId;
      item.price = Number(variant.price) || item.price;
      item.available = isPurchasable(null, variant, item.forcedSoldOut);
      item.checked = item.isCurrent ? item.available : item.available && item.checked;
      var nextImage = imageUrl(variant.featured_image);
      if (nextImage) item.image = nextImage;
      if (item.card) {
        var img = qs(item.card, '.custom-bundle__card-image img');
        if (img && item.image) img.src = item.image;
        item.card.classList.toggle('is-unchecked', !item.checked);
      }
      if (item.checkbox) {
        item.checkbox.checked = item.checked;
        item.checkbox.disabled = item.isCurrent || !item.available;
      }
      if (item.row) {
        item.row.classList.toggle('is-disabled', !item.available);
        item.row.classList.toggle('is-locked', !!item.isCurrent);
      }
      setRowPrice(item);
      syncBundleVisibility();
    }

    function onVariantChange(event) {
      if (!root.isConnected) {
        document.removeEventListener('theme:variant:change', onVariantChange);
        return;
      }
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      var productSection = event.target && event.target.closest && event.target.closest('[data-product-handle]');
      if (productSection && productHandle && productSection.getAttribute('data-product-handle') !== productHandle) return;
      var current = null;
      var i;
      for (i = 0; i < items.length; i++) {
        if (items[i].isCurrent) current = items[i];
      }
      if (current) applyVariant(current, variant);
    }

    document.addEventListener('theme:variant:change', onVariantChange);

    function openThemeCartDrawer() {
      if (window.a11y) window.a11y.lastElement = atc;
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
      var drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
    }

    if (atc) {
      atc.addEventListener('click', function () {
        var selected = selectedItems();
        if (!selected.length || atc.classList.contains('is-loading')) return;
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.classList.remove('is-visible');
        }
        atc.classList.add('is-loading');
        atc.disabled = true;

        fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: selected.map(function (item) {
              return { id: item.variantId, quantity: item.quantity };
            })
          })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok || (result.data && result.data.status)) {
              throw new Error((result.data && (result.data.description || result.data.message)) || 'Could not add items to cart');
            }
            openThemeCartDrawer();
          })
          .catch(function (error) {
            if (errorEl) {
              errorEl.textContent = error.message || 'Could not add items to cart';
              errorEl.classList.add('is-visible');
            }
          })
          .finally(function () {
            atc.classList.remove('is-loading');
            updateUI();
          });
      });
    }

    waitForBundler(WAIT_MS).then(function (bundles) {
      bundle = pickBundle(bundles, productId, productHandle);
      if (!bundle) {
        showEmpty();
        return;
      }

      var products = bundleProducts(bundle).sort(function (a, b) {
        return (Number(a.sequence) || 0) - (Number(b.sequence) || 0);
      });
      products.sort(function (a, b) {
        var aCurrent = String(a.id) === String(productId) || (productHandle && a.handle === productHandle);
        var bCurrent = String(b.id) === String(productId) || (productHandle && b.handle === productHandle);
        if (aCurrent === bCurrent) return 0;
        return aCurrent ? -1 : 1;
      });

      return Promise.all(products.map(function (bundleProduct) {
        return fetchProduct(catalogRoot, bundleProduct.handle).then(function (productJson) {
          var isCurrent = String(bundleProduct.id) === String(productId) || (productHandle && bundleProduct.handle === productHandle);
          var variant = pickVariant(productJson, bundleProduct, isCurrent ? preferredVariantId : '');
          if (!variant) return null;
          var quantity = Number(bundleProduct.quantity) || 1;
          var forcedSoldOut = hasOutOfStockTag(productJson);
          var available = isPurchasable(productJson, variant, forcedSoldOut);
          return {
            productId: String(bundleProduct.id),
            variantId: Number(variant.id),
            title: productJson.title || bundleProduct.title || '',
            image: productImage(productJson, variant),
            price: Number(variant.price) || 0,
            forcedSoldOut: forcedSoldOut,
            available: available,
            checked: available,
            quantity: quantity > 0 ? quantity : 1,
            required: !!bundleProduct._required,
            discountAmount: bundleProduct.discount_amount,
            allowedIds: allowedVariantIds(bundleProduct),
            isCurrent: isCurrent
          };
        }).catch(function () { return null; });
      }));
    }).then(function (nextItems) {
      if (!nextItems) return;
      items = nextItems.filter(Boolean);
      syncBundleVisibility();
    }).catch(function () {
      showEmpty();
    });
  }
})();
